import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-anthracite text-white">
      <div className="max-w-screen-xl mx-auto px-8 lg:px-16 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <div className="font-serif text-2xl font-semibold text-white">SPDB</div>
              <div className="text-xs tracking-luxury font-sans font-light text-white/40 mt-0.5">STUDIO</div>
            </div>
            <p className="text-sm font-sans text-white/50 leading-relaxed max-w-xs mb-8">
              Single Property Digital Branding für Luxusimmobilien in der Schweiz. Vom Inserat zur Ikone.
            </p>
            {/* Social Media */}
            <div className="flex items-center gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="SPDB Studio auf Instagram"
                className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/40 hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="SPDB Studio auf LinkedIn"
                className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/40 hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-line text-sm" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs tracking-ultra font-sans font-medium text-white/30 uppercase mb-8">Navigation</p>
            <ul className="flex flex-col gap-4">
              {[
                { label: "Home", href: "/" },
                { label: "The Private Gallery", href: "/gallery" },
                { label: "Makler-Service", href: "/makler-service" },
                { label: "Über uns", href: "/ueber-uns" },
                { label: "Kontakt", href: "/kontakt" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm font-sans text-white/50 hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs tracking-ultra font-sans font-medium text-white/30 uppercase mb-8">Kontakt</p>
            <div className="flex flex-col gap-4">
              <a
                href="mailto:studio@sbdm-studio.ch"
                className="flex items-center gap-3 text-sm font-sans text-white/50 hover:text-gold transition-colors duration-300"
              >
                <i className="ri-mail-line text-white/30 text-base flex-shrink-0" />
                studio@sbdm-studio.ch
              </a>
              <a
                href="tel:+41766827078"
                className="flex items-center gap-3 text-sm font-sans text-white/50 hover:text-gold transition-colors duration-300"
              >
                <i className="ri-phone-line text-white/30 text-base flex-shrink-0" />
                +41 76 682 70 78
              </a>
              <p className="flex items-center gap-3 text-sm font-sans text-white/50">
                <i className="ri-map-pin-line text-white/30 text-base flex-shrink-0" />
                Zürich, Schweiz
              </p>
              <Link
                to="/kontakt"
                className="btn-gold inline-block mt-4 text-center"
              >
                Diskrete Anfrage
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <p className="text-xs tracking-ultra font-sans font-medium text-white/30 uppercase mb-8">Rechtliches</p>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="/impressum" className="text-sm font-sans text-white/50 hover:text-gold transition-colors duration-300">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm font-sans text-white/50 hover:text-gold transition-colors duration-300">
                  Datenschutzerklärung
                </Link>
              </li>
              <li>
                <Link to="/agb" className="text-sm font-sans text-white/50 hover:text-gold transition-colors duration-300">
                  AGB
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs font-sans text-white/25 tracking-wider">
            &copy; 2026 SPDB Studio GmbH. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs font-sans text-white/20 tracking-wider italic font-serif">
            Diskretion. Ästhetik. Präzision.
          </p>
        </div>
      </div>
    </footer>
  );
}
